module.exports = "<div class=\"grid-container\">\n  <mat-card-title>Eventos</mat-card-title>\n</div>\n<app-events></app-events>\n"